import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${API_BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !original.url.includes("/auth/") &&
      !original.url.includes("/customer/")
    ) {
      original._retry = true;
      if (!refreshPromise) {
        refreshPromise = api
          .post("/auth/refresh")
          .finally(() => {
            refreshPromise = null;
          });
      }
      try {
        await refreshPromise;
        return api(original);
      } catch (refreshErr) {
        console.warn("Session refresh failed", refreshErr?.response?.status || refreshErr?.message);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return "Une erreur est survenue. Merci de réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
